export const companyLines = (c) => {
  if (!c) return ["ops@heliopolispharmaceuticals.com"];
  const lines = [c.legal_name, ...(c.address || "").split("\n").map((s) => s.trim()).filter(Boolean)];
  if (c.tax_number) lines.push(`${c.tax_label || "Tax No."}: ${c.tax_number}`);
  const contact = [c.phone, c.email, c.website].filter(Boolean).join(" · ");
  if (contact) lines.push(contact);
  return lines.filter(Boolean);
};

// Draws the company block under the logo (jsPDF, A4 mm). Returns the y of the separator line.
export function drawCompanyBlock(doc, company, gray, x = 20, y0 = 40) {
  const lines = companyLines(company);
  let y = y0;
  lines.forEach((l, i) => {
    doc.setFont("helvetica", i === 0 && company ? "bold" : "normal"); doc.setFontSize(i === 0 && company ? 9 : 8); doc.setTextColor(...(i === 0 && company ? [20, 20, 20] : gray));
    doc.text(String(l).slice(0, 90), x, y);
    y += i === 0 && company ? 4.5 : 3.8;
  });
  return Math.max(46, y + 2);
}
